export const VERTICAL_CODES = ['stays', 'dining'] as const
export type VerticalCode = (typeof VERTICAL_CODES)[number]

export const DEFAULT_VERTICAL: VerticalCode = 'stays'

export function isVerticalCode(value: unknown): value is VerticalCode {
  return typeof value === 'string' && (VERTICAL_CODES as readonly string[]).includes(value)
}
